// extracted by mini-css-extract-plugin
export default {"button":"exportButton_button__Epnoy","download-icon":"exportButton_download-icon__oQG2N"};